import { parseISO, format } from "date-fns";

export const apiUrl = () => {
	//return "https://websiteapidevelopment.raywhite.co.id";
	return "https://websiteapi.raywhite.co.id";
};

export const BaseWebsite = () => {
	return "https://www.raywhite.co.id/";
};

export const CDNWebsite = () => {
	return "https://cdn.raywhite.co.id/";
};

export function clean(s) {
	if (s == null) {
		return "";
	}
	if (typeof s === "undefined") {
		return "";
	}
	return s;
}

export function GetIndexByValue(items, id) {
	//let i = items.map((item) => item.id).indexOf(id);
	let i = items.findIndex((item) => item.id === parseNumber(id));

	if (i >= 0) {
		return items[i];
	} else {
		return null;
	}
}

export function AllowedUsergroup(ss, target) {
	const sss = ss.split(",");

	if (sss.length > 0) {
		for (let i = 0; i < sss.length; i++) {
			if (sss[i].trim() === target) {
				return true;
			}
		}
	} else {
		return false;
	}

	return false;
}

export function parseDate(s) {
	if (s === "" || s === "0000-00-00" || s === "0000-00-00 00:00:00") {
		return "";
	} else {
		return format(parseISO(s), "dd MMM yyyy");
	}
}

export function parseNumber(s) {
	if (s == null) {
		return 0;
	}

	if (typeof s === "undefined") {
		return 0;
	}

	let ns = s;
	if (s > 0 || s === 0 || s < 0) {
	} else {
		ns = s.replaceAll(",", "");
	}

	if (isNaN(parseFloat(ns))) {
		return 0;
	} else {
		return parseFloat(ns);
	}
}
